export default __webpack_public_path__ + "static/media/petrovicky.0d94f348.png";